import './StatusLabel.css'

function StatusLabel() {
    return null
}

export default StatusLabel
